import { ProductCard, ProductCardProps } from '@ui/product/product-card.tsx';

export const ProductsGrid = ({
  items = [],
  className,
}: {
  items?: (ProductCardProps | undefined)[];
  className?: string;
}) => {
  return (
    <div className="flex flex-col items-center justify-between py-3">
      <ul
        className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 md:gap-x-4 lg:gap-x-6 gap-y-6 md:gap-y-8 w-full ${className}`}
      >
        {items.map((item, index) => (
          <li key={index}>
            <ProductCard {...item} />
          </li>
        ))}
      </ul>
    </div>
  );
};
